export const sortAlphabetically = (a: string | null, b: string | null) => {
  if (a === b)
    // identical? return 0
    return 0;
  else if (a === null)
    // a is null? last
    return 1;
  else if (b === null)
    // b is null? last
    return -1;
  // compare, negate if descending
  else return a.localeCompare(b);
};

export const sortObjectsAlphabetically =
  <T>(getFieldValue: (val: T) => string | null) =>
  (a: T, b: T) =>
    sortAlphabetically(getFieldValue(a), getFieldValue(b));
